import { createSlice } from '@reduxjs/toolkit';
import { _setEpisodeListModule } from './stopModuleAction';
import initialState from './stopModuleInitialState';

const stopEpisodeListSlice = createSlice({
  name: 'stop/episodeListModule',
  initialState,
  reducers: {
    resetEpisodeListModule: () => null,
    setEpisodeListModule: _setEpisodeListModule,
  },
});

export const { resetEpisodeListModule, setEpisodeListModule } = stopEpisodeListSlice.actions;

export default stopEpisodeListSlice.reducer;
